import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";
import {
  correctQuestionsFromList,
  correctQuestionsFromListByCategory,
  incorrectQuestionsFromList,
  incorrectQuestionsFromListByCategory,
  answeredQuestionsFromListByCategory,
  unansweredQuestionsFromList,
  unansweredQuestionsFromListByCategory,
  questionsFromListByCategory,
  categoriesFromList,
} from "../Data";

import ProgressBars from "./ProgressBars";
import AnswerRow from "./AnswerRow";

const ResultsQuestionsHeading = ({ title, questions, total, children }) => {
  return (
    <div className="row">
      <div className="col ps-0 pe-1">
        {title}{" "}
        <ResultsBlockPercentage value={questions?.length} total={total} />
        <div className="float-end">{children}</div>
      </div>
    </div>
  );
};

const ResultsQuestionsList = ({ questions }) => {
  if (questions.length === 0) {
    return (
      <div className="alert alert-danger" role="alert">
        No questions match the selected filter.
      </div>
    );
  }
  return (
    <div className="list-group list-group-flush">
      {questions.map((questionID) => (
        <AnswerRow key={questionID} questionID={questionID} />
      ))}
    </div>
  );
};

const ResultsBlockPercentage = ({ value, total }) => {
  const percentage = value / (total || 1);

  const percent = (() => {
    return Intl.NumberFormat(undefined, {
      style: "percent",
      maximumFractionDigits: 2,
    }).format(percentage);
  })();

  return !isNaN(percentage) ? <span>({percent})</span> : null;
};

const TotalResultsBlock = ({ title, slug, correct, questions }) => {
  const passed = correct.length / questions.length >= (2 / 3);

  const passedFraction = `${correct.length}/${questions.length}`;

  const passedString = passed ? "Pass" : "Fail";

  const passedClass = passed ? "bg-success" : "bg-danger";
  return (
    <div className="accordion-item">
      <div
        className="accordian-header"
        id={`totalAnswersHeader-${slug}`}
        data-bs-toggle="collapse"
        data-bs-target={`#totalAnswersContent-${slug}`}
        aria-expanded="false"
        aria-controls={`totalAnswersContent-${slug}`}
      >
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#totalAnswersContent-${slug}`}
          aria-expanded="false"
          aria-controls={`totalAnswersContent-${slug}`}
        >
          <div className="container-fluid">
            <ResultsQuestionsHeading title={title}>
              <span className={`badge fs-6 ${passedClass}`}>
                {passedFraction} ({passedString})
              </span>
            </ResultsQuestionsHeading>
          </div>
        </button>
      </div>
      <div
        className="accordion-collapse collapse d-print-block"
        id={`totalAnswersContent-${slug}`}
        aria-labelledby={`totalAnswersHeader-${slug}`}
      >
        <div className="accordion-body p-0">
          <ResultsQuestionsList questions={questions} />
        </div>
      </div>
    </div>
  );
};

const Results = ({ questions }) => {
  let { answers } = useContext(AnswersContext);

  let categories = categoriesFromList(questions);
  let questionsCategory = questionsFromListByCategory(questions);

  let correct = correctQuestionsFromList(answers, questions);
  let incorrect = incorrectQuestionsFromList(answers, questions);
  let unanswered = unansweredQuestionsFromList(answers, questions);
  let answered = answeredQuestionsFromListByCategory(answers, questions);

  return (
    <>
      <ProgressBars
        answers={answers}
        questions={questions}
        showAnswers={true}
      />
      <main>
        <div className="accordion accordion-flush">

          <TotalResultsBlock
            title={"Total"}
            slug={"total"}
            correct={correct}
            incorrect={incorrect}
            unanswered={unanswered}
            answered={answered}
            questions={questions}
          />

          {categories.map((category, idx) => {
            let correctCat = correctQuestionsFromListByCategory(answers, questions, category)[category] || [];
            let incorrectCat = incorrectQuestionsFromListByCategory(answers, questions, category)[category] || [];
            let unansweredCat = unansweredQuestionsFromListByCategory(answers, questions, category)[category] || [];
            return (
              <TotalResultsBlock
                title={category}
                slug={idx}
                correct={correctCat}
                incorrect={incorrectCat}
                unanswered={unansweredCat}
                questions={questionsCategory[category]}
              />
            )
          })}
        </div>
      </main>
    </>
  );
};

export default Results;
